// extracted by mini-css-extract-plugin
export default {"number":"ServiceNumber_number__Ag-z4"};